import { render, staticRenderFns } from "./ReadOnly.vue?vue&type=template&id=5b9bde60&scoped=true&"
import script from "./ReadOnly.vue?vue&type=script&lang=ts&"
export * from "./ReadOnly.vue?vue&type=script&lang=ts&"
import style0 from "./ReadOnly.vue?vue&type=style&index=0&id=5b9bde60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9bde60",
  null
  
)

export default component.exports